import React from 'react';
import highlightPartOfString from './highlightPartOfString';

const buildHighlightedQuery = ({
  query,
  suggestionItem
}) => {
  // verifica se a query é igual a sugestão, caso seja a palavra retorna sem nenhuma alteração
  if (query === suggestionItem.term) {
    return query;
  } // separa palavra por palavra, assim podendo realizar a verificação


  const queryTerms = query.split(' ');
  const suggestionItemTerms = suggestionItem.term.split(' ');
  return suggestionItemTerms // filter para verificar que não é uma string vazia
  .filter(suggestionTerms => Boolean(suggestionTerms)).map((suggestionTerms, i) => {
    // o find verifica se a pesquisa feita pelo usuário existe na lista de sugestão
    const presentQueryTerm = queryTerms.find(queryT => suggestionTerms.toLowerCase().includes(queryT.toLowerCase())); // caso não existe retorna a palavra em negrito

    if (!presentQueryTerm) {
      return /*#__PURE__*/React.createElement("strong", {
        key: i.toString()
      }, suggestionTerms);
    } // caso existe verifica se é a palavra inteira


    if (presentQueryTerm === suggestionTerms) {
      return suggestionTerms;
    } // caso exista e não seja a palavra inteira vai para o verificador de parte da string


    return highlightPartOfString(presentQueryTerm, suggestionTerms, i);
  }).reduce((prev, curr) => [prev, ' ', curr]);
};

export default buildHighlightedQuery;